import React from 'react';

const TermsAndConditions = () => {
    // Responsive Inline Styles using clamp(), %, and CSS units
    const styles = {
        pageContainer: {
            width: '100%',
            minHeight: '100vh',
            backgroundColor: '#f8fafc',
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            color: '#334155',
            lineHeight: '1.6',
            boxSizing: 'border-box',
        },
        headerBanner: {
            position: 'relative',
            // ডায়নামিক প্যাডিং: ছোট স্ক্রিনে ৪০px, বড় স্ক্রিনে ৬০px
            padding: 'clamp(40px, 6vw, 60px) clamp(15px, 4vw, 20px)',
            background: 'linear-gradient(135deg, #BD06D3 0%, #00BFFF 100%)',
            color: '#ffffff',
            textAlign: 'center',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        },
        bannerContent: {
            maxWidth: '800px',
            margin: '0 auto',
        },
        mainTitle: {
            // ডায়নামিক ফন্ট: মোবাইলে ১.৭rem, বড় পর্দায় ২.৫rem
            fontSize: 'clamp(1.7rem, 4vw, 2.5rem)',
            fontWeight: '800',
            marginBottom: '8px',
            letterSpacing: '-0.025em',
            color: '#ffffff',
        },
        subTitle: {
            fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
            fontWeight: '500',
            opacity: '0.95',
            marginBottom: '16px',
        },
        effectiveDate: {
            display: 'inline-block',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(4px)',
            padding: '6px 16px',
            borderRadius: '50px',
            fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
            fontWeight: '600',
            border: '1px solid rgba(255, 255, 255, 0.3)',
        },
        wrapper: {
            maxWidth: '1440px',
            margin: '0 auto',
            padding: '0px clamp(10px, 3vw, 20px)',
            boxSizing: 'border-box',
        },
        cardContainer: {
            padding: 'clamp(20px, 4vw, 40px) clamp(10px, 3vw, 40px)',
            boxSizing: 'border-box',
        },
        mainHeading: {
            fontSize: 'clamp(1.4rem, 3vw, 1.875rem)',
            fontWeight: '700',
            color: '#0f172a',
            borderBottom: '3px solid #BD06D3',
            paddingBottom: '8px',
            marginBottom: '20px',
            display: 'inline-block',
        },
        subHeading: {
            fontSize: 'clamp(1.1rem, 2.5vw, 1.25rem)',
            fontWeight: '700',
            color: '#BD06D3',
            marginTop: '24px',
            marginBottom: '12px',
        },
        paragraph: {
            fontSize: 'clamp(0.925rem, 2vw, 1rem)',
            color: '#475569',
            marginBottom: '16px',
            textAlign: 'left',
            lineHeight: '1.6',
        },
        list: {
            paddingLeft: 'clamp(18px, 3vw, 24px)',
            marginBottom: '20px',
            color: '#475569',
        },
        listItem: {
            marginBottom: '8px',
            fontSize: 'clamp(0.925rem, 2vw, 1rem)',
        },
        contactBox: {
            backgroundColor: '#f8fafc',
            padding: 'clamp(16px, 3vw, 24px)',
            borderRadius: '12px',
            borderLeft: '4px solid #BD06D3',
            marginTop: '16px',
            color: '#334155',
            fontSize: 'clamp(0.875rem, 2vw, 0.95rem)',
            // লম্বা ইমেইল বা ইউআরএল যেন স্ক্রিনের বাইরে না ভেঙে যায়
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
        },
        link: {
            color: '#00BFFF',
            textDecoration: 'none',
            fontWeight: '600',
        }
    };

    return (
        <div style={styles.pageContainer}>

            {/* Header Banner */}
            <div style={styles.headerBanner}>
                <div style={styles.bannerContent}>
                    <h1 style={styles.mainTitle}>Terms & Conditions</h1>
                    <p style={styles.subTitle}>Iconic Greenland Limited</p>
                    <div style={styles.effectiveDate}>
                        Effective Date: 07 July 2026
                    </div>
                </div>
            </div>

            {/* Main Content Container */}
            <div style={styles.wrapper}>
                <div style={styles.cardContainer}>

                    <h1 style={styles.mainHeading}>Terms and Conditions</h1>

                    <p style={styles.paragraph}>
                        Welcome to Iconic Greenland Limited. By accessing our website, browsing our property listings, or submitting inquiries through our lead generation forms, you agree to comply with the following Terms and Conditions. These terms govern the relationship between Iconic Greenland and its potential clients and stakeholders.
                    </p>

                    {/* Section 1 */}
                    <h2 style={styles.subHeading}>1. Agreement to Terms</h2>
                    <p style={styles.paragraph}>
                        By using our digital platforms or filling out inquiry forms on Facebook, Instagram, or our website, you confirm that you have read and accepted these terms. These terms apply to all visitors, users, and others who wish to access our real estate services.
                    </p>

                    {/* Section 2 */}
                    <h2 style={styles.subHeading}>2. Real Estate Services</h2>
                    <p style={styles.paragraph}>
                        Iconic Greenland Limited provides premium residential apartments, commercial spaces, and land development services in Bangladesh. The details regarding flat sizes, locations, and architectural designs provided on the website are for informational purposes.
                    </p>
                    <ul style={styles.list}>
                        <li style={styles.listItem}>Luxury Residential Apartment Sales</li>
                        <li style={styles.listItem}>Commercial Space Development and Management</li>
                        <li style={styles.listItem}>Property Consultation and Joint Venture Agreements</li>
                        <li style={styles.listItem}>Interior Design and Post-Handover Maintenance</li>
                    </ul>

                    {/* Section 3 */}
                    <h2 style={styles.subHeading}>3. Booking and Payments</h2>
                    <p style={styles.paragraph}>
                        Formal booking of any property is subject to the signing of a standard "Allotment Agreement" and payment of the booking money. Installment schedules, down payments, and final handover payments are strictly governed by the specific project's allotment letter.
                    </p>

                    {/* Section 4 */}
                    <h2 style={styles.subHeading}>4. Accuracy of Information</h2>
                    <p style={styles.paragraph}>
                        While we aim for accuracy, the 3D renders, architectural drawings, and virtual tours displayed are artistic impressions. The final product may have minor variations during construction as per structural requirements or government regulations.
                    </p>

                    {/* Section 5 */}
                    <h2 style={styles.subHeading}>5. Intellectual Property</h2>
                    <p style={styles.paragraph}>
                        All project brochures, floor plans, company logos, and marketing materials are the exclusive property of Iconic Greenland Limited. Unauthorized reproduction or use of these materials for commercial purposes is prohibited.
                    </p>

                    {/* Section 6 */}
                    <h2 style={styles.subHeading}>6. Project Timelines & Handover</h2>
                    <p style={styles.paragraph}>
                        Iconic Greenland strives to deliver projects within the stipulated timeframe. However, delays caused by "Force Majeure" (natural disasters, political instability, or government policy changes) are beyond the company's liability.
                    </p>

                    {/* Section 7 */}
                    <h2 style={styles.subHeading}>7. Communication Consent</h2>
                    <p style={styles.paragraph}>
                        By submitting your phone number or email, you authorize Iconic Greenland Limited to contact you via phone calls, SMS, or WhatsApp to provide project updates, price lists, and site visit schedules.
                    </p>

                    {/* Contact Section */}
                    <h2 style={styles.subHeading}>Contact Us</h2>
                    <p style={styles.paragraph}>
                        For any clarification regarding these terms, please contact our corporate office:
                    </p>

                    <div style={styles.contactBox}>
                        <strong style={{ color: '#BD06D3', fontSize: '1.05rem', display: 'block', marginBottom: '6px' }}>
                            Iconic Greenland Limited
                        </strong>
                        Suite: 8/A&B, LilyPond Center, 3, R. K Mission Road, Motijheel, Dhaka-1000<br />
                        Phone: +880 1937-900900<br />
                        Email: <a href="mailto:info@iconicgreenland.com" style={styles.link}>info@iconicgreenland.com</a><br />
                        Website: <a href="https://iconicgreenland.com" target="_blank" rel="noreferrer" style={styles.link}>www.iconicgreenland.com</a>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;